import React from 'react';
import { Card } from '../../ui/Card';
import { Button } from '../../ui/Button';
import { AccountingTypeSelector } from './sections/AccountingTypeSelector';
import { ConsolidationSection } from './sections/ConsolidationSection';
import { UnitsSection } from './sections/UnitsSection';
import { useAccountingLevels } from '../../../utils/hooks/useAccountingLevels';
import toast from 'react-hot-toast';

export function AccountingLevelSettings() {
  const { settings, saving, error, updateSettings, addUnit, removeUnit, saveSettings } = useAccountingLevels();

  const handleSubmit = async (e: React.FormEvent) => {
    e.preventDefault();
    const ok = await saveSettings();
    if (ok) {
      toast.success('Niveaux de comptabilité enregistrés');
    } else {
      toast.error(error ?? 'Erreur lors de la sauvegarde');
    }
  };

  return (
    <form onSubmit={handleSubmit}>
      <Card title="Configuration des niveaux de comptabilité">
        <div className="space-y-6">
          <AccountingTypeSelector
            value={settings.type}
            onChange={(type) => updateSettings({ type })}
          />

          {settings.type === 'multi' && (
            <>
              <ConsolidationSection
                consolidation={settings.consolidation}
                rules={settings.consolidationRules}
                onConsolidationChange={(consolidation) => updateSettings({ consolidation })}
                onRulesChange={(rules) => updateSettings({ consolidationRules: rules })}
              />

              <UnitsSection
                units={settings.units}
                mainCurrency={settings.mainCurrency}
                onAddUnit={addUnit}
                onRemoveUnit={removeUnit}
              />
            </>
          )}

          <div className="flex justify-end border-t pt-4">
            <Button type="submit" disabled={saving}>
              {saving ? 'Enregistrement...' : 'Enregistrer les paramètres'}
            </Button>
          </div>
        </div>
      </Card>
    </form>
  );
}